/* eslint-disable no-mixed-operators */
import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../store/store";
import {
  changeMode,
  updateProperty,
  validateData,
} from "../../actions";
import Constants from "../../../../core/libraries/Constants";
import { IAccessMediator, IAccessMediatorValidator, ReportStatus } from "../../types";
import Helper from "../../../../core/libraries/Helper";
import { init } from "../../actions";
import {
  getReportDispatch,
  getDocumentTypesDispatch,
  updateReportDispatch,
  deleteReportDispatch,
  restartUploadWorkflow,
} from "../../thunks";
import RbButton, {
  ButtonSize,
  ButtonType,
} from "../../../../bosch-react/components/button/RbButton";
import { IUserProfile } from "../../../Auth/types";
import { confirmDialog, showDialog, showToastMessage } from "../../../Dialog/actions";
import { removeAliasDomain } from "../../../../utils/converter";
import RbLabel, { LabelSize } from "../../../../bosch-react/components/label/RbLabel";

interface CommandBarProps {
  userProfile: IUserProfile | undefined;
  accessMediator: IAccessMediator;
  init: typeof init;
  changeMode: typeof changeMode;
  getReportDispatch: any;
  getDocumentTypesDispatch: any;
  updateReportDispatch: any;
  updateProperty: any;
  restartUploadWorkflow: any;
  deleteReportDispatch: any;
  validateData: typeof validateData;
  confirmDialog: typeof confirmDialog;
  showDialog: typeof showDialog;
  showToastMessage: typeof showToastMessage;
  // from parent
  hasAdminPermission: boolean | undefined;
}

class CommandBar extends React.Component<CommandBarProps, any> {

  constructor(props: CommandBarProps) {
    super(props);
    this.renderEditButton = this.renderEditButton.bind(this);
    this.renderMoveButton = this.renderMoveButton.bind(this);
    this.renderDeleteButton = this.renderDeleteButton.bind(this);
    this.renderUpdateButton = this.renderUpdateButton.bind(this);
    this.renderRestartButton = this.renderRestartButton.bind(this);
    this.renderCancelButton = this.renderCancelButton.bind(this);

    this.checkAndConfrimaDeletion = this.checkAndConfrimaDeletion.bind(this);
    this.cancelChanges = this.cancelChanges.bind(this);
    this.renderCopyButton = this.renderCopyButton.bind(this);
    // Helper functions
    this.getMode = this.getMode.bind(this);
  }

  render() {
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row common-padding-row">&nbsp;</div>
        <div className="ms-Grid-row common-padding-row">
          {this.renderEditButton()}
          {this.renderMoveButton()}
          {this.renderDeleteButton()}
          {this.renderUpdateButton()}
          {this.renderRestartButton()}
          {this.renderCancelButton()}
          {this.renderCopyButton()}
        </div>
      </div>
    );
  }

  shouldWaitROUValidation = () => {
    const { isROULoading, isSPFOLoading, isLLCoordinatorLoading } = this.props.accessMediator
    return isROULoading || isSPFOLoading || isLLCoordinatorLoading
  }

  renderEditButton() {
    const hasPermission = !!Helper.checkHasPermissionOnDocument(this.props.accessMediator.report, this.props.userProfile, true)
    if (this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.VIEW && hasPermission) {
      return (
        <React.Fragment>
          <RbButton
            label="Edit"
            size={ButtonSize.Small}
            onClick={() => {
              !!this.props.userProfile?.loginName &&
                this.props.changeMode(Constants.ACCESS_MEDIATOR_MODE.EDIT);
            }}
          />
          &nbsp;
        </React.Fragment>
      );
    }
    return null
  }


  renderMoveButton() {
    if (
      this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.VIEW &&
      !!Helper.checkHasPermissionOnDocument(this.props.accessMediator.report, this.props.userProfile) &&
      this.props.accessMediator.status === ReportStatus.PUBLISHED
    ) {
      return (
        <React.Fragment>
          <RbButton
            type={ButtonType.Secondary}
            size={ButtonSize.Small}
            label="Reclassify"
            onClick={() => {
              Helper.openNewTab(`${process.env.REACT_APP_MOVE_SINGLE}/${this.props.accessMediator.report.id}`)
            }}
          />
          &nbsp;
        </React.Fragment>
      );
    }
    return null;
  }

  renderDeleteButton() {
    if (
      this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.VIEW &&
      this.props.userProfile?.permissions?.isSuperAdmin &&
      this.props.accessMediator.status === ReportStatus.PUBLISHED
    ) {
      return (
        <React.Fragment>
          <RbButton
            type={ButtonType.Secondary}
            size={ButtonSize.Small}
            label="Delete"
            onClick={() => {
              this.checkAndConfrimaDeletion();
            }}
          />
          &nbsp;
        </React.Fragment>
      );
    }
    return null;
  }

  renderUpdateButton() {
    const shouldIncludeSubmitterCheckIfStatusIsDeclined = this.props.accessMediator.report.status === ReportStatus.DECLINED ? true : false;
    if (
      (this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.EDIT)
    ) {
      return (
        <React.Fragment>
          {!!Helper.checkHasPermissionOnDocument(this.props.accessMediator.report, this.props.userProfile, shouldIncludeSubmitterCheckIfStatusIsDeclined) && <RbButton
            disabled={this.shouldWaitROUValidation()}
            label="Update"
            size={ButtonSize.Small}
            onClick={() => {
              this.props.validateData(() => {
                this.props.showDialog(Constants.DIALOG_MESSAGE.UPDATE);
                this.props.updateReportDispatch(
                  {
                    ...this.props.accessMediator.report,
                    modifiedBy: removeAliasDomain(this.props.userProfile?.loginName ?? ""),
                    modified: new Date().toISOString(),
                    oldData: this.props.accessMediator.oldReport,
                  },
                  (rs: boolean) => {
                    this.props.showDialog(false);
                    this.props.confirmDialog(
                      Constants.REPORT_MESSAGE.UPDATE.TITLE,
                      (rs === true
                        ? Constants.REPORT_MESSAGE.UPDATE.SUCCESS
                        : Constants.REPORT_MESSAGE.UPDATE.FAILED
                      ).replace("{0}", this.props.accessMediator.report.title),
                      true,
                      () => {
                        this.cancelChanges();
                      }
                    );
                  }
                );
              });
            }}
          /> ||
            <p className="ms-TextField-errorMessage">
              <RbLabel className="error-txt" size={LabelSize.Small}>{Constants.MESSAGE_NO_SUFFICIENT_PERMISSION} {Constants.MESSAGE_CONTACT_MAILBOX}</RbLabel>
            </p>}

          &nbsp;
        </React.Fragment>
      );
    }
    return null;
  }

  _handleRestartUpload = () => {
    this.props.validateData((result: boolean) => {
      console.log("Validate data result: ", result);
      this.props.showDialog(Constants.DIALOG_MESSAGE.RESTART);
      this.props.restartUploadWorkflow(
        this.props.accessMediator.report,
        (rs: any) => {
          this.props.showDialog(false);
          this.props.confirmDialog(
            Constants.REPORT_MESSAGE.RESTART.TITLE,
            (rs === true
              ? Constants.REPORT_MESSAGE.RESTART.SUCCESS
              : Constants.REPORT_MESSAGE.RESTART.FAILED
            ).replace("{0}", this.props.accessMediator.report.title),
            true,
            () => {
              this.cancelChanges();
              if (rs === true) {
                window.close();
              }
            }
          );
        }
      );
    });
  }

  renderRestartButton() {
    if (this.props.accessMediator.status === ReportStatus.DECLINED && this.props.hasAdminPermission===true) {
      return (
        <React.Fragment>
          <RbButton
            disabled={this.shouldWaitROUValidation()}
            label="Restart workflow"
            size={ButtonSize.Small}
            onClick={this._handleRestartUpload}
          />
          &nbsp;
        </React.Fragment>
      );
    }
    return null;
  }

  renderCancelButton() {
    if (
      (this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.EDIT) &&
      this.props.accessMediator.status !== ReportStatus.DECLINED
    ) {
      return (
        <React.Fragment>
          <RbButton
            type={ButtonType.Secondary}
            size={ButtonSize.Small}
            label="Cancel"
            onClick={this.cancelChanges}
          />
          &nbsp;
        </React.Fragment>
      );
    }
    return null;
  }

  renderCopyButton() {
   return (
        <React.Fragment>
          <RbButton
            type={ButtonType.Secondary}
            label="Copy Link"
            size={ButtonSize.Small}
            onClick={() => {
              this.CopyAccessMediatorUrl();
            }}
          />
          &nbsp;
        </React.Fragment>
      );
  }

  checkAndConfrimaDeletion() {
    this.props.confirmDialog(
      Constants.CONFIRMATION_MESSAGE.DELETE_REPORT.TITLE,
      Constants.CONFIRMATION_MESSAGE.DELETE_REPORT.CONTENT.replace(
        "{0}",
        this.props.accessMediator.report.title
      ),
      false,
      () => {
        this.props.showDialog(Constants.DIALOG_MESSAGE.DELETE);
        this.props.deleteReportDispatch(
          this.props.accessMediator.report.id,
          (rs: boolean) => {
            this.props.showDialog(false);
            this.props.confirmDialog(
              Constants.REPORT_MESSAGE.REMOVE.TITLE,
              (rs === true
                ? Constants.REPORT_MESSAGE.REMOVE.SUCCESS
                : Constants.REPORT_MESSAGE.REMOVE.FAILED
              ).replace("{0}", this.props.accessMediator.report.title),
              true,
              () => {
                if (rs === true) {
                  window.close();
                  this.cancelChanges();
                }
                else {
                }
              }
            );
          }
        );
      }
    );
  }

  cancelChanges() {
    let id: string = this.props.accessMediator.report.id;
    Helper.openAMPage(id, false)
  }

  // Helper fucntions
  CopyAccessMediatorUrl() {
    let link =
      this.props.accessMediator.report.accessMediatorPath;
    // Copy link
    const el = document.createElement("textarea");
    el.style.position = "fixed";
    el.value = link;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.props.showToastMessage(
      Constants.TOAST_MESSAGE_CODE.SUCCESS,
      "The link is copied into your clipboard. You can paste it anywhere."
    );
  }

  getMode(mode: string = "") {
    let result = "";
    switch (mode.toLowerCase()) {
      case Constants.ACCESS_MEDIATOR_MODE.VIEW:
      case "edit":
      case "move": {
        result = mode;
        break;
      }
      default: {
        result = Constants.ACCESS_MEDIATOR_MODE.VIEW;
        break;
      }
    }
    return result;
  }
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
  accessMediator: state.accessMediator,
});

export default connect(mapStateToProps, {
  init,
  changeMode,
  getReportDispatch,
  getDocumentTypesDispatch,
  updateReportDispatch,
  updateProperty,
  restartUploadWorkflow,
  deleteReportDispatch,
  validateData,
  confirmDialog,
  showDialog,
  showToastMessage,
})(CommandBar);
